import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { LoadingView } from "../common/LoadingView";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, profile, loading, profileLoading } = useAuth();

  if (loading) return <LoadingView label="Loading profile..." />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && profileLoading) return <LoadingView label="Loading profile..." />;
  if (adminOnly && profile?.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}
